<template>
  <div :key="`render-${renderKey}`" class="tabela-padrao">
    <!-- {{tamanhoContainer}} -->
    <!-- {{ renderKey }}
    <div @click="teste">teste</div> -->
    <!-- {{ conteudoTotal.map(p => p.vigente) }} -->
    <!-- {{ conteudoTotal[0].vigente }}
    {{ mostraAlertaVermelho(conteudoTotal[0]) }} -->
    <!-- {{ conteudoTotal[0]}} -->
    <div
      v-if="!semTitulo"
      :style="`grid-template-columns: ${templateColumnsAcao};`"
      class="tabela-padrao-wrapper-titulo"
    >
      <div v-if="radio" class="titulo-tabela-padrao titulo-acao"></div>
      <div v-else-if="selecao" class="titulo-tabela-padrao titulo-acao">
        <input
          v-if="!!conteudoTotal.length && !todosLoading"
          class="input-interno"
          type="checkbox"
          v-model="selecionouTudo"
        />
        <div v-else-if="todosLoading">
          <LoadingPadraoContainerMini delay="5000" classe="azul" />
        </div>
      </div>
      <div
        @click="ordenar(item)"
        :class="[
          'titulo-tabela-padrao',
          {
            'ordem-crescente':
              strOrdem == estruturaTabela.find(f => f.nome == item).valor && !reverse
          },
          {
            'ordem-decrescente':
              strOrdem == estruturaTabela.find(f => f.nome == item).valor && reverse
          }
        ]"
        v-for="(item, index) in label"
        :key="index"
      >
        {{ item }}
      </div>
      <div v-if="acao" class="titulo-tabela-padrao titulo-acao">
        <!-- <font-awesome-icon icon="bolt" /> -->
        AÇÕES
      </div>
    </div>

    <div class="corpo-tabela-linha" v-for="(conteudo, index1) in conteudoPaginado" :key="index1">
      <div
        :style="`grid-template-columns: ${templateColumnsAcao};`"
        :class="[
          'tabela-padrao-wrapper',
          {
            'tabela-padrao-alerta-vermelho': mostraAlertaVermelho(conteudo) || mostraErro(conteudo)
          }
        ]"
        v-b-tooltip.window.bottom.html
        :title="
          conteudo.repetido
            ? mensagemRepetido
            : mostraErro(conteudo)
            ? erro
            : mostraAlertaVermelho(conteudo)
            ? alertaVermelho
            : ''
        "
      >
        <div
          v-if="mostraErro(conteudo)"
          :class="[
            'tabela-padrao-exclamation',
            'tabela-padrao-alerta',
            'alerta-vermelho',
            { 'tabela-padrao-altura-compacto': compacto }
          ]"
        >
          <font-awesome-icon icon="exclamation-circle" />
        </div>
        <div
          v-else-if="mostraAlertaVermelho(conteudo)"
          @click="handleAlertaVermelhoClick(conteudo)"
          :class="[
            'tabela-padrao-exclamation',
            'tabela-padrao-alerta',
            'alerta-vermelho',
            { 'tabela-padrao-altura-compacto': compacto }
          ]"
        >
          <font-awesome-icon icon="exclamation-triangle" />
        </div>
        <div
          v-else-if="mostraAlertaAmarelo(conteudo)"
          @click="handleAlertaAmareloClick(conteudo)"
          :class="[
            'tabela-padrao-exclamation',
            'tabela-padrao-alerta',
            { 'tabela-padrao-altura-compacto': compacto }
          ]"
          v-b-tooltip.window.top
          :title="alertaAmarelo"
        >
          <font-awesome-icon icon="exclamation-triangle" />
        </div>
        <div v-if="radio" :class="['selecao-input', { 'tabela-padrao-altura-compacto': compacto }]">
          <input
            v-if="!mostraAlertaVermelho(conteudo) && !mostraErro(conteudo)"
            :ref="`selecao${index1}`"
            class="input-interno"
            type="radio"
            :value="conteudo[idRadio]"
            v-model="radioModelLocal"
          />
        </div>
        <div
          v-else-if="selecao"
          :class="['selecao-input', { 'tabela-padrao-altura-compacto': compacto }]"
        >
          <!-- {{ checkLoading }} -->
          <input
            v-if="!mostraAlertaVermelho(conteudo) && !mostraErro(conteudo) && !checkLoading"
            :ref="`selecao${index1}`"
            class="input-interno"
            type="checkbox"
            v-model="conteudo.selecionado"
          />
          <div v-else-if="checkLoading">
            <LoadingPadraoContainerMini delay="5000" classe="" />
          </div>
        </div>
        <div
          :ref="`container${index1}${index2}`"
          @click="
            mostraErro(conteudo)
              ? null
              : mostraAlertaVermelho(conteudo) && alertaVermelhoClick
              ? handleAlertaVermelhoClick(conteudo)
              : selecao || radio
              ? handleInputClick(index1)
              : clickLinha && !conteudo.repetido
              ? clickLinha(conteudo)
              : null
          "
          :class="[
            'corpo-tabela-padrao',
            { 'corpo-tabela-compacto': compacto },
            {
              'corpo-tabela-click':
                selecao ||
                radio ||
                clickLinha ||
                (mostraAlertaVermelho(conteudo) && alertaVermelhoClick)
            },
            { 'corpo-tabela-repetido': conteudo.repetido },
            { 'corpo-tabela-fade': !!mostraTooltip(conteudo[item], index1, index2) },
            {
              'corpo-tabela-fade-repetido':
                !!mostraTooltip(conteudo[item], index1, index2) && conteudo.repetido
            },
            {
              'corpo-tabela-alinhamento-centro':
                estruturaTabela[index2].alinhamento == 'centro' &&
                !mostraTooltip(conteudo[item], index1, index2)
            },
            {
              'corpo-tabela-destacado': estruturaTabela[index2].destacado
            }
          ]"
          v-for="(item, index2) in valor"
          :key="`render-${index1}${index2}`"
          v-b-tooltip
          :title="mostraTooltip(conteudo[item], index1, index2)"
        >
          <div :ref="`conteudo${index1}${index2}`">
            <div v-if="conteudo[item]">
              {{ conteudo[item] }}
            </div>
            <div
              class="tabela-padrao-exclamation"
              v-else-if="estruturaTabela[index2].alerta"
              v-b-tooltip.window.top
              :title="estruturaTabela[index2].alerta"
            >
              <font-awesome-icon icon="exclamation-triangle" />
            </div>
            <div v-else>-</div>
          </div>
        </div>
        <div
          v-if="acao"
          :class="['corpo-tabela-padrao', { 'corpo-tabela-compacto': compacto }, 'corpo-acao']"
        >
          <div v-if="cnaeTabela" class="tabela-padrao-cnae">
            <div class="corpo-tabela-icone-cnae" @click="cnaeTabela(conteudo)">CNAEs</div>
          </div>
          <div v-if="editTabela" class="tabela-padrao-editar" @click="editTabela(conteudo)">
            <font-awesome-icon icon="edit" />
          </div>
          <div v-if="syncTabela" class="tabela-padrao-editar" @click="syncTabela(conteudo)">
            <font-awesome-icon icon="sync-alt" />
          </div>
          <div v-if="deleteTabela" class="tabela-padrao-deletar" @click="deleteTabela(conteudo)">
            <font-awesome-icon icon="times" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPadraoContainerMini from "@/components/LoadingPadrao/LoadingPadraoContainerMini.vue";

export default {
  name: "TabelaPadrao",
  components: {
    LoadingPadraoContainerMini
  },
  props: {
    apagaOrdenacao: Boolean,
    compacto: Boolean,
    semTitulo: Boolean,
    conteudoPaginado: Array,
    conteudoTotal: Array,
    estruturaTabela: Array,
    templateColumns: String,
    mensagemRepetido: String,
    acao: String,
    selecao: String,
    radio: String,
    idRadio: String,
    radioModel: Number,
    alertaAmarelo: String,
    alertaVermelho: String,
    erro: String,
    caminhoAlertaAmarelo: String,
    caminhoAlertaVermelho: String,
    caminhoErro: String,
    alertaAmareloClick: Function,
    alertaVermelhoClick: Function,
    clickLinha: Function,
    deleteTabela: Function,
    editTabela: Function,
    syncTabela: Function,
    cnaeTabela: Function
  },
  data() {
    return {
      checkLoading: false,
      todosLoading: false,
      bugLoading: false,
      strOrdem: "",
      radioModelLocal: null,
      reverse: false,
      conteudoFiltrado: [],
      selecionouTudo: false,
      renderKey: 0
    };
  },
  created() {
    this.conteudoFiltrado = [...this.conteudoPaginado];
    this.$nextTick(() => {
      this.renderKey += 1;
    });
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    apagaOrdenacao() {
      this.strOrdem = "";
    },
    radioModel() {
      this.radioModelLocal = this.radioModel;
    },
    radioModelLocal() {
      this.$emit("radioModel", this.radioModelLocal);
    },
    conteudoPaginado() {
      this.conteudoFiltrado = [...this.conteudoPaginado];
      this.$nextTick(() => {
        this.renderKey += 1;
      });
    },
    async selecionouTudo() {
      if (this.selecao) {
        // let conteudo = [...this.conteudoTotal.map(item => ({ ...item }))];
        if (this.selecionouTudo) {
          let delay = 0;
          if (this.conteudoTotal.length > 500 && !this.bugLoading) {
            this.checkLoading = true;
            delay = 50;
          }
          this.bugLoading = false;
          setTimeout(async () => {
            await new Promise(resolve => {
              this.conteudoTotal.forEach(e =>
                e[this.caminhoAlertaVermelho] && !e[this.caminhoErro]
                  ? this.$set(e, "selecionado", true)
                  : this.$set(e, "selecionado", false)
              );
              resolve();
            });
            this.checkLoading = false;
          }, delay);
          // this.alteraConteudo(conteudo);
        } else if (
          this.conteudoTotal
            .filter(f => f[this.caminhoAlertaVermelho] && !f[this.caminhoErro])
            .every(p => p.selecionado == true)
        ) {
          let delay = 0;
          if (this.conteudoTotal.length > 500) {
            this.checkLoading = true;
            delay = 50;
          }
          setTimeout(async () => {
            await new Promise(resolve => {
              this.conteudoTotal.forEach(e => this.$set(e, "selecionado", false));
              // this.alteraConteudo(conteudo);
              resolve();
            });
            this.checkLoading = false;
          }, delay);
        }
      }
    },
    conteudoTotal: {
      deep: true,
      handler() {
        if (this.selecao) {
          if (
            this.conteudoTotal
              .filter(f => f[this.caminhoAlertaVermelho] && !f[this.caminhoErro])
              .every(p => p.selecionado == true)
          ) {
            this.bugLoading = true;
            this.selecionouTudo = true;
          } else {
            this.bugLoading = false;
            this.selecionouTudo = false;
          }
        } else if (this.radio) {
        }
      }
    }
  },
  computed: {
    label() {
      if (this.estruturaTabela) {
        return this.estruturaTabela.map(p => p.nome);
      }
      return [];
    },
    valor() {
      if (this.estruturaTabela) {
        return this.estruturaTabela.map(p => p.valor);
      }
      return [];
    },
    templateColumnsAcao() {
      if (this.acao || this.selecao || this.radio) {
        return `${this.selecao ? this.selecao : ""} ${this.radio ? this.radio : ""} ${
          this.templateColumns
        } ${this.acao ? this.acao : ""}`;
      }
      return this.templateColumns;
    }
  },
  methods: {
    handleResize() {
      this.renderKey++;
    },
    handleInputClick(index1) {
      if (this.selecao || this.radio) {
        this.$refs[`selecao${index1}`][0].click();
      }
    },
    mostraErro(conteudo) {
      if (this.erro && this.caminhoErro && conteudo[this.caminhoErro]) {
        return true;
      }
      return false;
    },
    mostraAlertaVermelho(conteudo) {
      if (
        (this.alertaVermelho || this.alertaVermelho == "") &&
        this.caminhoAlertaVermelho &&
        (!conteudo[this.caminhoAlertaVermelho] || conteudo[this.caminhoAlertaVermelho] == 0)
      ) {
        return true;
      }
      return false;
    },
    mostraAlertaAmarelo(conteudo) {
      if (
        (this.alertaAmarelo || this.alertaAmarelo == "") &&
        this.caminhoAlertaAmarelo &&
        !conteudo[this.caminhoAlertaAmarelo]
      ) {
        return true;
      }
      return false;
    },
    mostraTooltip(titulo, index1, index2) {
      if (
        titulo &&
        this.tamanhoConteudo(index1, index2) > this.tamanhoContainer(index1, index2) - 12
      ) {
        return titulo;
      }
      return "";
    },
    tamanhoContainer(index1, index2) {
      if (
        this.$refs[`container${index1}${index2}`] &&
        this.$refs[`container${index1}${index2}`][0]
      ) {
        return this.$refs[`container${index1}${index2}`][0].offsetWidth;
      }
      return "";
    },
    tamanhoConteudo(index1, index2) {
      if (this.$refs[`conteudo${index1}${index2}`] && this.$refs[`conteudo${index1}${index2}`][0]) {
        return this.$refs[`conteudo${index1}${index2}`][0].offsetWidth;
      }
      return "";
    },
    ordenar(item) {
      let strOrdem = this.estruturaTabela.find(f => f.nome == item).valor;
      if (strOrdem == this.strOrdem) {
        this.reverse = !this.reverse;
        this.conteudoTotal.reverse();
        return;
      }
      this.reverse = false;
      if (strOrdem == "data_alteracao" || strOrdem == "data_efeito") {
        this.conteudoTotal.sort((a, b) => {
          if (a[strOrdem] == null) {
            return;
          }

          var dataA = this.converterData(a[strOrdem]).toString();
          var dataB = this.converterData(b[strOrdem]).toString();
          return dataA.localeCompare(dataB);
        });
      } else if (typeof this.conteudoTotal[0][strOrdem] == "number") {
        this.conteudoTotal.sort((a, b) => {
          if (a[strOrdem] == null) {
            return;
          }
          if (
            a[strOrdem] == "-" ||
            a[strOrdem] == "" ||
            a[strOrdem] == "0" ||
            b[strOrdem] == "-" ||
            b[strOrdem] == "" ||
            b[strOrdem] == "0"
          ) {
            return a[strOrdem] == "-" || a[strOrdem] == "" || a[strOrdem] == "0" ? 1 : -1;
          }
          return a[strOrdem] - b[strOrdem];
        });
      } else {
        this.conteudoTotal.sort((a, b) => {
          if (a[strOrdem] == null) {
            return;
          }
          if (
            a[strOrdem] == "-" ||
            a[strOrdem] == "" ||
            a[strOrdem] == "0" ||
            b[strOrdem] == "-" ||
            b[strOrdem] == "" ||
            b[strOrdem] == "0"
          ) {
            return a[strOrdem] == "-" || a[strOrdem] == "" || a[strOrdem] == "0" ? 1 : -1;
          }
          return a[strOrdem].localeCompare(b[strOrdem]);
        });
      }
      this.strOrdem = strOrdem;
    },
    converterData(data) {
      // Separa a data em dia, mês e ano
      if (data && data != "" && data != "-") {
        const [dia, mes, ano] = data.split("/");

        // Retorna a data no formato "mm/dd/yyyy"
        return Date.parse(`${mes} ${dia} ${ano}`);
      } else {
        return 0;
      }
    },
    handleAlertaVermelhoClick(conteudo) {
      if (this.alertaVermelhoClick) {
        this.alertaVermelhoClick(conteudo);
      }
    },
    handleAlertaAmareloClick(conteudo) {
      if (this.alertaAmareloClick) {
        this.alertaAmareloClick(conteudo);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tabela-padrao {
  width: 100%;
  font-size: 14px;
}
.tabela-padrao-wrapper-titulo {
  width: 100%;
  // background: red;
  display: grid;
  border-radius: 2px 2px 0 0;
  color: var(--branco);
  background-color: var(--azul4) !important;
}
.tabela-padrao-wrapper {
  width: 100%;
  position: relative;
  // background: red;
  display: grid;
}
.titulo-tabela-padrao {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  cursor: pointer;
  padding: 0 0.5rem;
  height: 2rem;
}
.titulo-acao {
  cursor: default;
}
.corpo-tabela-padrao {
  display: flex;
  user-select: none;
  padding: 0.5rem 12px;
  // margin: 0 5px;
  line-height: 24px;
  height: 38px;
  overflow: hidden;
  white-space: nowrap;
}
.corpo-tabela-compacto {
  padding: 0 12px;
  height: 24px;
}
.corpo-tabela-fade {
  position: relative;
  &::after {
    content: "";
    height: 100%;
    width: 35px;
    background: linear-gradient(to right, transparent, var(--branco) 80%);
    position: absolute;
    top: 0;
    right: 0;
  }
}
.corpo-tabela-fade-repetido {
  &::after {
    background: linear-gradient(to right, transparent, var(--cinza01) 80%);
  }
}
.corpo-tabela-linha {
  background: var(--branco);
  border-top: 1px solid #ddd;
  &:last-child {
    border-bottom: 1px solid #ddd;
  }
}
.corpo-tabela-alinhamento-centro {
  justify-content: center;
}
.corpo-tabela-destacado {
  font-weight: bold;
  color: var(--azul4);
}
.corpo-acao {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  font-size: 16px;
  // height: 38px;
  // background: blue;
  > div {
    cursor: pointer;
    margin: 0 10px;
    transition: scale 0.3s ease-in-out;
    &:hover {
      scale: 1.2;
    }
  }
}
.tabela-padrao-editar {
  color: var(--azul4);
}
.tabela-padrao-deletar {
  color: var(--vermelho3);
}
.tabela-padrao-cnae {
  display: flex;
  align-items: center;
  height: 24px;
}
.corpo-tabela-icone-cnae {
  background: var(--azul4);
  font-size: 9px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  border-radius: 2px;

  // font-family: 'Roboto Condensed';
  color: var(--branco);
}
.tabela-padrao-exclamation {
  width: 15px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--amarelo2);
}
.alerta-vermelho {
  color: var(--vermelho2);
}
.ordem-crescente {
  background: linear-gradient(var(--azul4), var(--azul3));
}
.ordem-decrescente {
  background: linear-gradient(var(--azul3), var(--azul4));
}
.selecao-input {
  display: flex;
  justify-content: center;
  height: 37px;
  align-items: center;
}
.input-interno {
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.tabela-padrao-alerta {
  position: absolute;
  height: 37px;
  left: -22px;
  cursor: pointer;
}
.tabela-padrao-alerta-vermelho {
  background: var(--vermelho0);
  .corpo-tabela-fade {
    &::after {
      background: linear-gradient(to right, transparent, var(--vermelho0) 90%);
    }
  }
}
.corpo-tabela-click {
  cursor: pointer;
}
.tabela-padrao-altura-compacto {
  height: 24px;
}
.corpo-tabela-repetido {
  background: var(--cinza01);
  color: var(--cinza1);
  cursor: default;
}
</style>
